module.exports = __webpack_public_path__ + "static/media/ASB6000 - 2.2ce7d51e.jpeg";